import React from 'react';
import Title from '../../title';
import $ from "jquery";
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import Loading from '../../loading';
import { Dropdown, Button, Grid } from 'semantic-ui-react';
import View from './view';
import ViewCreditOrder from './viewCreditOrder';
import Add from './add';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

class CreditNote extends React.Component {

  state = {
    customerOption: [], selectedCustomer: '', creditNotes: [], menuPermission: [],
    fromDate: this.getFormatedDate(new Date(), 'fromDate'),
    toDate: this.getFormatedDate(new Date(), 'toDate'), invoice: []
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x;
    if (interval == 'fromDate') {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    else {
      x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
  }

  componentDidMount() {
    this.getPermission();
  }

  getPermission() {
    let menuPermission = Permission('credit-note', this.props.menus);
    if (menuPermission.view) {
      this.getCreditNotes();
    }
    this.setState({ menuPermission })
  }

  getCreditNotes() {
    let context = this;
    context.setState({  load: true, message: 'Getting Credit Note!!!' })
    $.ajax({
      type: 'POST', url: Server() + 'invoice/getallcreditnote.php',
      data: { 'fromDate': context.state.fromDate, 'toDate': context.state.toDate },
      success: function(data) {
        console.log(data);
        console.log('data data');
        try {
          data = JSON.parse(data);
          context.setState({ creditNotes: data, load: false })
        } catch (error) {
          alert('Error1!!!')
          context.setState({ load: false })
        }
      },
      error: function(e) {
        alert('Try again!!');
        context.setState({ load: false });
      }
      });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  makeIntoDecimal(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (value) {
      value = 0;
    }
    return value;
  }

  cancelCreditNoteMaster(id) {
    if (!this.state.menuPermission.cancel) {
      alert('You Are Not Allow To Cancel!!!');
      return;
    }
    this.setState({ cancelId: id, openCancelConfirmationDialog: true })
  }

  cancel() {
    let context = this;
    context.setState({  load: true, message: 'Cancel Credit Note!!!' })
    $.ajax({
      type: 'POST', url: Server() + 'invoice/cancel.php',
      data: { 'id': context.state.cancelId },
      success: function(data) {
        console.log(data);
        if (data == 1) {
          let creditNotes = context.state.creditNotes;
          let newCreditNotes = [];
          creditNotes.map((c) => {
            if (c.id != context.state.cancelId) {
              newCreditNotes.push(c);
            }
          })
          context.setState({ creditNotes: newCreditNotes, openCancelConfirmationDialog: false, load: false })
        }
        else {
          alert('Failed!!!');
          context.setState({ load: false, openCancelConfirmationDialog: false })
        }
      },
      error: function(e) {
        alert('Try again!!');
        context.setState({ load: false });
      }
      });
  }

  openPDF(id) {
    let open = Server() + "pdf/creditnote/creditnote.php?id="+id;
    window.open(open);
  }


  render() {
    let i = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        
        <Title title={'Credit Note'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ? 
          (
            <div>
              <div style={{margin: '2px'}}>
                  <div style={{display: 'flex'}}>
                      <div style={{marginLeft: 5}}>
                          From Date<br/>
                          <input type="date" id="date" value={this.state.fromDate}
                              onChange={this.handleChange('fromDate')} style={{width: '100%', height: 35 }} />
                      </div>
                      <div style={{marginLeft: 5}}>
                          To Date<br/>
                          <input type="date" id="date" value={this.state.toDate} onChange={this.handleChange('toDate')}
                              style={{width: '100%', height: 35 }} />
                      </div>

                      <div style={{marginLeft: 5}}>
                        <br/>
                        <Button primary onClick={this.getCreditNotes.bind(this)}>Submit</Button>
                      </div>
                      
                      <div style={{marginLeft: 5}}>
                        <Add menuPermission={this.state.menuPermission} fromDate={this.state.fromDate} toDate={this.state.toDate} />
                      </div>
                  </div>
                  <div style={{margin: '6px'}}>
                    <table width="100%" id='table'>
                        <tr>
                            <th id="th">Sino</th>
                            <th id="th">Date</th>
                            <th id="th">Customer Name</th>
                            <th id="th">Credit Voucher</th>
                            <th id="th">Invoice Voucher</th>
                            <th id="th">Total Item</th>
                            <th id="th">Credit Value</th>
                            <th id="th">View</th>
                            <th id="th">Cancel</th>
                        </tr>
                        {
                            this.state.creditNotes.map((c) => {
                              let date = c.timestamp.split(' ')[0];
                              date = date.split('-')[2]+'-'+date.split('-')[1]+'-'+date.split('-')[0];
                                return (
                                    <tr>
                                      <td>{i++}</td>
                                      <td>{date}</td>
                                      <td>{c.cid+'->'+c.cname}</td>

                                      



                                      <td><u style={{color: 'blue'}} onClick={this.openPDF.bind(this, c.id)}>{c.credit_voucher}</u></td>
                                      <td>{c.invoice_voucher}</td>
                                      <td><center>{c.items}</center></td>
                                      <td><div style={{textAlign: 'right', fontWeight: 'bold'}}>{'Rs. '+this.makeIntoDecimal(this.convertIntoNumber(c.value))}</div></td>
                                      <td>
                                        <center>
                                          <ViewCreditOrder menuPermission={this.state.menuPermission} id={c.id} credit_voucher={c.credit_voucher} />
                                        </center>
                                      </td>
                                      <td onClick={this.cancelCreditNoteMaster.bind(this, c.id)}>
                                        <center style={{color: 'red'}}>
                                          Cancel
                                        </center>
                                      </td>
                                    </tr>
                                )
                            })
                        }
                    </table>
                  </div>
              </div>
              <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}  open={this.state.openCancelConfirmationDialog}
                onClose={ () => { this.setState({ openCancelConfirmationDialog: false }) }} aria-labelledby="max-width-dialog-title">
                <DialogTitle id="max-width-dialog-title">{'Confimation'}</DialogTitle>
                <DialogContent>
                  Are Sure to Remove this Credit Note?<br/><br/>
                  <Grid>
                    <Grid.Column mobile={16} computer={8} tablet={16}>
                      <Button negative fluid onClick={ () => { this.setState({ openCancelConfirmationDialog: false }) }}>NO</Button>
                    </Grid.Column> 
                    <Grid.Column mobile={16} computer={8} tablet={16}>
                      <Button positive fluid onClick={this.cancel.bind(this)}>YES</Button>
                    </Grid.Column> 
                  </Grid>
                </DialogContent>
              </Dialog>
            </div>
          ):
          (<center>You Are Not Allow To Access This Menu!!!</center>)
        }
        
      </div>
    );
  }
}

export default CreditNote;
